// extracted by mini-css-extract-plugin
export default {"DetailsTable":"DetailsTable_DetailsTable__SU-hk","actions_column":"DetailsTable_actions_column__jZ92m","record_icon_wrapper":"DetailsTable_record_icon_wrapper__1rwya"};